import SiteFooter from '../components/layout/SiteFooter';

const hours = [
  { day: 'Monday', time: '8:00 AM - 5:00 PM' },
  { day: 'Tuesday', time: '8:00 AM - 5:00 PM' },
  { day: 'Wednesday', time: '8:00 AM - 5:00 PM' },
  { day: 'Thursday', time: '8:00 AM - 5:00 PM' },
  { day: 'Friday', time: '8:00 AM - 5:00 PM' },
  { day: 'Saturday', time: '8:00 AM - 5:00 PM' },
  { day: 'Sunday', time: 'Closed' },
];

function IconFacebook() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 fill-current">
      <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.5-3.88 3.78-3.88 1.1 0 2.24.2 2.24.2v2.46H15.2c-1.25 0-1.64.78-1.64 1.58V12h2.8l-.45 2.89h-2.35v6.99A10 10 0 0 0 22 12z" />
    </svg>
  );
}

function IconInstagram() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 fill-current">
      <path d="M7.75 2h8.5A5.76 5.76 0 0 1 22 7.75v8.5A5.76 5.76 0 0 1 16.25 22h-8.5A5.76 5.76 0 0 1 2 16.25v-8.5A5.76 5.76 0 0 1 7.75 2zm8.33 1.72h-.92a.86.86 0 0 0 0 1.72h.92a.86.86 0 1 0 0-1.72zM12 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 1.72A3.28 3.28 0 1 1 8.72 12 3.28 3.28 0 0 1 12 8.72z" />
    </svg>
  );
}

function IconTiktok() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5 fill-current">
      <path d="M14.5 3h2.28a4.9 4.9 0 0 0 3.22 3.18v2.33a7.13 7.13 0 0 1-3.22-.92v6.2a5.8 5.8 0 1 1-5.24-5.76v2.36a3.46 3.46 0 1 0 2.96 3.4V3z" />
    </svg>
  );
}

function AboutPage() {
  return (
    <div className="bg-brand-bg">
      <main className="mx-auto max-w-7xl px-6 pb-16 pt-10 sm:px-8 sm:pb-24 sm:pt-14">
        <section className="rounded-3xl border border-brand-petal/80 bg-gradient-to-r from-brand-mist/90 via-brand-bg to-brand-sage/70 px-7 py-10 shadow-sm sm:px-10">
          <h1 className="text-5xl text-brand-text sm:text-6xl">About Best Brows & Beauty</h1>
          <p className="mt-4 max-w-3xl text-base leading-8 text-brand-text/80 sm:text-lg">
            We are a women-focused beauty studio in Harrisburg offering brows, lashes, waxing, and hair
            services in a clean, welcoming environment. Our goal is simple: personalized service,
            polished results, and a relaxing experience every time.
          </p>
        </section>

        <section className="mt-10 grid gap-6 lg:grid-cols-2">
          <article className="rounded-3xl border border-brand-petal bg-white p-7 shadow-sm">
            <h2 className="text-3xl text-brand-text">Open Hours</h2>
            <ul className="mt-5 divide-y divide-brand-petal/70">
              {hours.map((entry) => (
                <li key={entry.day} className="flex items-center justify-between py-3 text-sm sm:text-base">
                  <span className="font-semibold text-brand-deep">{entry.day}</span>
                  <span className="text-brand-text/80">{entry.time}</span>
                </li>
              ))}
            </ul>
          </article>

          <article className="rounded-3xl border border-brand-petal bg-white p-7 shadow-sm">
            <h2 className="text-3xl text-brand-text">Visit Us</h2>
            <p className="mt-3 text-brand-text/80">6301 Grayson Rd Suite A-131, Harrisburg, PA 17111</p>

            <div className="mt-5 overflow-hidden rounded-2xl border border-brand-petal">
              <iframe
                title="Best Brows and Beauty Map"
                src="https://www.google.com/maps?q=6301+Grayson+Rd+Suite+A-131+Harrisburg+PA+17111&output=embed"
                width="100%"
                height="320"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
                allowFullScreen
              />
            </div>
          </article>
        </section>

        <section className="mt-6 rounded-3xl border border-brand-petal bg-white p-7 shadow-sm">
          <h2 className="text-3xl text-brand-text">Connect With Us</h2>
          <p className="mt-2 text-brand-text/80">Follow us for updates, transformations, and promotions.</p>

          <div className="mt-5 flex flex-wrap gap-3">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="inline-flex items-center gap-2 rounded-full border border-brand-primary/35 px-4 py-2 text-sm font-semibold text-brand-deep transition hover:bg-brand-mist"
            >
              <IconFacebook />
              Facebook
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="inline-flex items-center gap-2 rounded-full border border-brand-primary/35 px-4 py-2 text-sm font-semibold text-brand-deep transition hover:bg-brand-mist"
            >
              <IconInstagram />
              Instagram
            </a>
            <a
              href="https://www.tiktok.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              className="inline-flex items-center gap-2 rounded-full border border-brand-primary/35 px-4 py-2 text-sm font-semibold text-brand-deep transition hover:bg-brand-mist"
            >
              <IconTiktok />
              TikTok
            </a>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}

export default AboutPage;